module.exports = __webpack_public_path__ + "img/red-envelopes-sended.0f07bf42.png";